import {
  FetchingUserInformationAction,
  LockSuccessAction,
  LogoutSuccessAction,
  UserReceivedAction,
  UserReceivedFailureAction
} from './auth-actions'
import { type AuthState } from './auth-types'
import { RestorePersistedDataAction } from '../persistence-middleware'
import { createReducer } from '@reduxjs/toolkit'

export const initialAuthState: AuthState = {
  loading: 0,
  isFetchingUserInformation: false,
  isAuthenticated: false,
  username: '',
  isAdmin: false,
  isAssignedToCompany: false,
  ownCompany: null,
  idToken: '',
  errorMessageKey: null
}

export const authReducer = createReducer(initialAuthState, builder => {
  builder.addCase(LockSuccessAction, (state, action) => {
    state.isFetchingUserInformation = false
    state.isAuthenticated = true
    state.errorMessageKey = null
    state.idToken = action.payload.token
  }).addCase(LogoutSuccessAction, (state, _action) => {
    // note: this was not set earlier due to accidentally setting 'isFetching: true' here using Object.assign that was
    // not detected as TypeScript to be invalid field for 'AuthState'
    // -> the comment can be removed once tested that this still works
    state.isFetchingUserInformation = false
    state.isAuthenticated = false
    state.loading = 0
  }).addCase(FetchingUserInformationAction, (state, action) => {
    state.loading += 1
    state.isFetchingUserInformation = true
  }).addCase(UserReceivedAction, (state, action) => {
    state.loading -= 1
    state.username = action.payload.user.username
    state.isAdmin = action.payload.user.systemAdmin
    state.isAssignedToCompany = action.payload.assignedToCompany
    state.isFetchingUserInformation = false
    state.ownCompany = action.payload.ownCompany ?? null
  }).addCase(UserReceivedFailureAction, (state, action) => {
    state.loading -= 1
    state.isFetchingUserInformation = false
    state.errorMessageKey = action.payload.errorKey
  }).addCase(RestorePersistedDataAction, (state, action) => {
    state.idToken = action.payload.idToken ?? ''
    state.isAuthenticated = (action.payload.idToken ?? '') !== ''
    state.isAdmin = action.payload.isAdmin
    state.isAssignedToCompany = action.payload.isAssignedToCompany
  })
})
